import LeafBg from '@/app/images/backgrounds/leaf-bg.jpg'
import LoginBgFika from '@/app/images/backgrounds/login-bg-FIKA.jpg'

export class BackgroundImages {
  static readonly leafBg = LeafBg
  static readonly loginBgFika = LoginBgFika

  private constructor() {}
}
